//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CategoryNavigation",
  props: {
    categories: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    list() {
      return this.categories?.[0].lenses || [];
    },
  },
}
